import * as React from 'react';
import { Order, Region } from '../BookingsCalendarTypes';

function useSelectedOrder(order?, regions?) {
    const [selectedOrder, setSelectedOrder] = React.useState<Order>(null);
    const [isAdvancedMode, setIsAdvancedMode] = React.useState<boolean>(false);
    const [availableRegions, setAvailableRegions] = React.useState<Region[]>(null);
    const [hideTravelTimes, setHideTravelTimes] = React.useState<boolean>(false);

    const handleHideTravelTime = () => {
        setHideTravelTimes(!hideTravelTimes);
    };

    const handleChangeAdvancedMode = React.useCallback(() => {
        setIsAdvancedMode((prevState) => !prevState);
        setHideTravelTimes((prevState) => false);
    }, []);

    const handleSelectedOrder = React.useCallback(
        (order: Order, regions: Region[]) => {
            setIsAdvancedMode(false);
            setHideTravelTimes(false);

            if (availableRegions === null && order) {
                setAvailableRegions(regions);
            }

            if (order != null) {
                order.executionTime = order.orderRows.reduce(
                    (n, { executionTime }) => n + executionTime,
                    0
                );
                setSelectedOrder(order);

                if (selectedOrder != null && selectedOrder.orderId != order.orderId) {
                    setSelectedOrder(order);
                }
            } else {
                setSelectedOrder(null);
            }
        },
        [selectedOrder, availableRegions]
    );

    return {
        selectedOrder,
        isAdvancedMode,
        availableRegions,
        handleSelectedOrder,
        handleChangeAdvancedMode,
        hideTravelTimes,
        handleHideTravelTime
    };
}

export default useSelectedOrder;
